import { render, staticRenderFns } from "./UserAddressTable.vue?vue&type=template&id=670846fc&scoped=true"
import script from "./UserAddressTable.vue?vue&type=script&lang=js"
export * from "./UserAddressTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670846fc",
  null
  
)

export default component.exports